// Some Laravel timestamps arrive as "YYYY-MM-DD HH:mm:ss" — UTC, but with no
// timezone marker, so native Date would read them as local time (and per spec
// the same is true for the T-separated form without an offset). Only strings
// that actually carry timezone info (trailing Z or a numeric offset) pass
// through untouched.
export const parseUtcDateTime = (value: string): Date => {
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value);

  return new Date(hasTimezone ? value : `${value.replace(' ', 'T')}Z`);
};
